import {Injectable, OnDestroy} from "@angular/core";
import {BehaviorSubject, Observable, Subscription} from "rxjs";
import {ProcessVariable, ProcessVariables, ProcessWithForm} from "../../interfaces/process-variables.interface";
import {FormViewerComponent} from "../../components/form-viewer/form-viewer.component";
import {map, take} from "rxjs/operators";
import {MatDialog, MatDialogRef} from "@angular/material";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ProcessService implements OnDestroy {
  processError = new BehaviorSubject('');
  private subs = new Subscription();

  constructor(private httpClient: HttpClient, private dialog: MatDialog, private dialogRef: MatDialogRef<FormViewerComponent>) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  getProcessWithForm(baseUrl: string, name: string): Observable<any> {
    return this.httpClient.get(baseUrl + `api/process/${name}/formDefinition`, {observe: 'response'})
      .pipe(
        map(response => response.body)
      );
  }

  public startProcess(baseUrl: string, process, processVariables?: ProcessVariables): Observable<any> {
    if (processVariables.multipartFiles && Array.isArray(processVariables.multipartFiles) && processVariables.multipartFiles.length > 0) {
      return this.startProcessWithMultipartFiles(baseUrl, process, processVariables);
    }
    return this.startProcessWithoutMultipartFiles(baseUrl, process, processVariables.variables);
  }

  private startProcessWithoutMultipartFiles(baseUrl: string, process, variables?: Array<ProcessVariable>): Observable<any> {
    const variablesObject = this.mapVariablesToVariablesObject(variables);
    return this.httpClient.post(baseUrl + `api/process/${process.key}/start`, variablesObject);
  }

  private startProcessWithMultipartFiles(baseUrl: string, process, processVariables?: ProcessVariables): Observable<any> {
    const formData = new FormData();
    processVariables.multipartFiles.forEach((multipartFile) => formData.append('multipartFiles', multipartFile.file, multipartFile.fileNameWithPath));
    formData.append('variables', this.getVariablesBlob(processVariables.variables));
    return this.httpClient.post(baseUrl + `api/process/v2/${process.key}/start`, formData);
  }

  private getVariablesBlob(variables: Array<ProcessVariable>): Blob {
    const variablesObject = this.mapVariablesToVariablesObject(variables);
    return new Blob([JSON.stringify(variablesObject, null, 2)], { type: 'application/json' });
  }

  private mapVariablesToVariablesObject(variables: Array<ProcessVariable>): object {
    const variablesObject = {};
    if (variables && Array.isArray(variables)) {
      variables.forEach((variable) => {
        variablesObject[variable.name] = variable.value;
      });
    }
    return variablesObject;
  }

  public initProcess(baseUrl: string, proc: ProcessWithForm) {
    if (proc.formJson) {
      return this.displayForm(baseUrl, proc.formJson, proc);
    } else {
      return this.initProcessStart(baseUrl, proc);
    }
  }

  displayForm(baseUrl: string, formJson, proc: ProcessWithForm): Observable<any> {
    this.processError.next('');
    return new Observable(observer => {
      this.dialog.open(FormViewerComponent, {
        panelClass: 'process-start-dialog',
        disableClose: true,
        data: {
          form: formJson,
          processKey: proc.key,
          processName: proc.name,
          formName: proc.formName,
          sendButtonText: proc.sendButtonText,
          processError: this.processError,
          dataViewBaseAPI: baseUrl,
          answers: proc.data,
          sendDelegate: (variables: ProcessVariables, callback: () => void) => {
            this.initProcessStart(baseUrl, proc, variables, callback)
              .subscribe(() => observer.next(true));
          }}});
    })

  }

  private initProcessStart( baseUrl: string, proc: ProcessWithForm, variables?: ProcessVariables, callback?: () => void): Observable<any> {
    return new Observable(observer => {
      this.subs.add(
        this.startProcess(baseUrl, proc, variables)
          .pipe(
            take(1)
          )
          .subscribe(
            (data) => {
              this.dialog.closeAll();
              observer.next(true);
            },
            (error) => {
              this.processError.next(error.error.message);
              if (callback) {
                callback();
              }
            },
          ),
      );
    })
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/process/process.service.ts